import { useState } from "react";
import environment from "../env";
import { DateTime } from "luxon";
import parsePhoneNumber from "libphonenumber-js";

const formatDateTime = (value) => value.set({milliseconds: 0}).toISO({ suppressMilliseconds: true})

function useRequestScheduledCallback() {
  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const requestScheduledCallback = async (data) => {
    setIsError(false);
    setIsLoading(true);
    setResponse(null);

    const callbackUTC = DateTime.fromISO(`${data.date}T${data.time}`).toUTC();
    const currentUTC = DateTime.now().toUTC();
    const cleanedPhoneNumber = parsePhoneNumber(data.phoneNumber, "GB").number

    const body = {
      clientRef: data.fileNumber,
      requestDatetime: formatDateTime(currentUTC),
      requestedCallbackDatetime: formatDateTime(callbackUTC),
      reason: data.accountType,
      phoneNumber: cleanedPhoneNumber,
    };

    const headers = {
      "Content-Type": "application/json",
      "x-api-key": environment.COMMS_JOURNEY_API_KEY,
      organisation: environment.ORGANISATION,
    };

    if (data.accountType !== "other") {
      headers.businessName = environment.ORGANISATION;
      headers.brand = environment.ORGANISATION;
      headers.product = data.accountType;
    }

    try {
      const result = await fetch(
        `${environment.COMMS_JOURNEY_API_URL}/requestScheduledCallback`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(body),
        }
      );

      const contentType = result.headers.get("content-type") || "";
      let data;

      if (contentType.includes("application/json")) {
        data = await result.json();
      } else {
        throw new Error(`Failed to submit callback: ${result.status} ${result.statusText}`);
      }

      if (result.status === 202) {
        setResponse("Callback scheduled successfully");
        return data;
      } else {
        setIsError(true);
        setResponse(result.status);
        throw new Error(`${result.status} ${result.statusText}`);
      }
    } catch (error) {
      setIsError(true);
      setResponse(error.message);
      throw error;
    } finally {
      setIsLoading(false); 
    }

  };

  return {
    response,
    isLoading,
    isError,
    requestScheduledCallback,
  };
}


export default useRequestScheduledCallback;
